import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { MobileNavCard, MobileNavCardProps } from "./mobile-nav-card";

const pageLabelCss = css({
    paddingBlock: token("space.150"),
    color: "#101214",
    textTransform: "uppercase",
    fontFamily: "Charlie Text",
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "1.667"
});

type MobileNavMenuPageProps = {
    pageLabel: string;
    cards: MobileNavCardProps[];
};

export const MobileNavMenuPage = ({
    pageLabel,
    cards
}: MobileNavMenuPageProps) => {
    return (
        <>
            <div css={pageLabelCss}>
                <span>{pageLabel}</span>
            </div>
            <div>
                {cards.map(({ key, ...rest }) => (
                    <MobileNavCard key={key} {...rest} />
                ))}
            </div>
        </>
    );
};
